// admin — Arabic (RTL). Keys are the English source text.
export default {
  "Say what's wrong and what to change.": "اذكر المشكلة وما يجب تغييره.",
  "At least {n} characters.": "على الأقل {n} حرفاً.",
  "The seller sees this message.": "يرى البائع هذه الرسالة.",
  "Cancel": "إلغاء",
  "Confirm": "تأكيد",
  "Reject {name}?": "رفض {name}؟",
  "Reject this store?": "رفض هذا المتجر؟",
  "The seller can fix the issue and ask for a new review.": "يمكن للبائع إصلاح المشكلة وطلب مراجعة جديدة.",
  "Reject store": "رفض المتجر",
  "Suspend {name}?": "إيقاف {name}؟",
  "Suspend this store?": "إيقاف هذا المتجر؟",
  "Their parts are hidden from buyers until you reactivate the store.": "تُخفى قطعه عن المشترين حتى تعيد تفعيل المتجر.",
  "Suspend store": "إيقاف المتجر",
  "Reject this part?": "رفض هذه القطعة؟",
  "The seller can edit the listing and send it back for review.": "يمكن للبائع تعديل العرض وإرساله للمراجعة من جديد.",
  "Reject part": "رفض القطعة",
  "Archive {name}?": "أرشفة {name}؟",
  "Archive this part?": "أرشفة هذه القطعة؟",
  "Archive part": "أرشفة القطعة",
  "Language": "اللغة",
  "PartHub Admin": "إدارة PartHub",
  "Control panel": "لوحة التحكم",
  "Admin": "المدير",
  "Sign out": "تسجيل الخروج",
  "Open navigation": "فتح القائمة",
  "Close navigation overlay": "إغلاق القائمة",
  "Failed to load analytics": "تعذّر تحميل التحليلات",
  "Search demand analytics": "تحليل عمليات البحث",
  "Understand what buyers search for, what they fail to find, and which vehicle demand is strongest.": "ما يبحث عنه المشترون، وما لا يجدونه، وأكثر السيارات طلباً.",
  "Top buyer queries": "أكثر عمليات البحث",
  "The most common search keywords currently used across the marketplace.": "الكلمات الأكثر استعمالاً في البحث.",
  "No query analytics available yet.": "لا توجد بيانات بعد.",
  "{n} searches": "{n} بحث",
  "Zero-result demand": "عمليات بحث بدون نتائج",
  "Queries that buyers search for but fail to find. This is direct supply opportunity.": "ما لا يجده المشترون: فرصة مباشرة للتزويد.",
  "No zero-result searches found yet.": "لا توجد عمليات بحث بدون نتائج.",
  "No keyword": "بدون كلمة",
  "{n} misses": "{n} بدون نتيجة",
  "any make": "أي علامة",
  "any model": "أي طراز",
  "any year": "أي سنة",
  "Top vehicle demand": "أكثر السيارات طلباً",
  "Most searched make/model/year combinations.": "أكثر تركيبات العلامة/الطراز/السنة بحثاً.",
  "No vehicle search analytics yet.": "لا توجد بيانات سيارات بعد.",
  "Recent search activity": "عمليات البحث الأخيرة",
  "Latest buyer search events flowing through the system.": "آخر عمليات بحث المشترين.",
  "No recent search events yet.": "لا توجد عمليات بحث حديثة.",
  "results: {n}": "النتائج: {n}",
  "unknown time": "وقت غير معروف",
  "Please enter your admin email and password.": "أدخل بريد المدير وكلمة المرور.",
  "Admin sign-in failed.": "فشل دخول المدير.",
  "Admin session": "جلسة المدير",
  "You are already signed in": "أنت مسجّل الدخول بالفعل",
  "Continue to the admin dashboard, moderation queues, or system overview.": "تابع إلى لوحة التحكم وطوابير المراجعة.",
  "Email": "البريد الإلكتروني",
  "Role": "الدور",
  "Continue": "متابعة",
  "Sellers": "البائعون",
  "Parts": "القطع",
  "Admin auth foundation": "فضاء المدير",
  "Sign in to admin panel": "الدخول إلى لوحة الإدارة",
  "Access sellers moderation, parts review, order oversight, reviews moderation, and categories management.": "مراجعة البائعين والقطع والتقييمات، متابعة الطلبيات وإدارة الأصناف.",
  "Admin scope": "صلاحيات المدير",
  "Review sellers and marketplace activity.": "مراجعة البائعين ونشاط السوق.",
  "Moderate parts, reviews, and operational flows.": "مراجعة القطع والتقييمات.",
  "Monitor categories, vehicles, and platform health.": "متابعة الأصناف والسيارات وحالة المنصة.",
  "Admin Panel": "لوحة الإدارة",
  "Password": "كلمة المرور",
  "Signing in...": "جارٍ الدخول…",
  "Sign In": "تسجيل الدخول",
  "Admin-only access. Non-admin accounts will be rejected during authentication.": "الدخول مخصّص للمديرين فقط.",
  "Failed to load categories": "تعذّر تحميل الأصناف",
  "Category name is required.": "اسم الصنف مطلوب.",
  "Category slug is required.": "رابط الصنف (slug) مطلوب.",
  "Category created successfully.": "تم إنشاء الصنف.",
  "Failed to create category": "تعذّر إنشاء الصنف",
  "Categories management": "إدارة الأصناف",
  "Marketplace categories": "أصناف السوق",
  "Manage the category structure used across parts listings and marketplace navigation.": "أدر الأصناف المستعملة في العروض والتنقّل.",
  "Create category": "أنشئ صنفاً",
  "Add a new category for admin moderation and seller listing organization.": "أضف صنفاً لتنظيم العروض.",
  "Category name": "اسم الصنف",
  "Brake System": "نظام الفرامل",
  "Slug": "الرابط (slug)",
  "Parent category": "الصنف الأب",
  "No parent": "بدون صنف أب",
  "Icon": "الأيقونة",
  "Creating...": "جارٍ الإنشاء…",
  "Categories list": "قائمة الأصناف",
  "Current marketplace taxonomy used across product listings.": "الأصناف المستعملة في العروض.",
  "Total": "المجموع",
  "Loading categories...": "جارٍ تحميل الأصناف…",
  "No categories found.": "لا توجد أصناف.",
  "None": "لا شيء",
  "Failed to load dashboard": "تعذّر تحميل لوحة التحكم",
  "Queue healthy": "لا يوجد تأخير",
  "No moderation backlog detected right now.": "لا يوجد تراكم في المراجعة.",
  "Needs attention": "يحتاج انتباهاً",
  "Pending moderation items should be reviewed soon.": "عناصر تنتظر المراجعة قريباً.",
  "Monitoring": "مراقبة",
  "Admin operations are being monitored.": "العمليات تحت المراقبة.",
  "Admin command center": "مركز التحكم",
  "Marketplace dashboard": "لوحة تحكم السوق",
  "Track moderation, supply growth, order activity, and marketplace health from one place.": "المراجعة والعرض والطلبيات وحالة السوق في مكان واحد.",
  "Operational status": "الحالة التشغيلية",
  "Total sellers": "مجموع البائعين",
  "All marketplace seller accounts": "كل حسابات البائعين",
  "Active parts": "القطع النشطة",
  "Currently active catalog listings": "العروض النشطة حالياً",
  "Total orders": "مجموع الطلبيات",
  "Marketplace order records": "سجلات الطلبيات",
  "Paid revenue": "الإيرادات المدفوعة",
  "Total revenue from paid orders": "مجموع الطلبيات المدفوعة",
  "Pending seller approvals": "بائعون ينتظرون الموافقة",
  "New or unresolved seller onboarding reviews": "متاجر جديدة تنتظر المراجعة",
  "Pending part reviews": "قطع تنتظر المراجعة",
  "Listings waiting for marketplace approval": "عروض تنتظر الموافقة",
  "Review seller queue": "طابور البائعين",
  "Approve trustworthy suppliers, reject weak submissions, and keep onboarding standards high.": "وافق على البائعين الموثوقين وارفض الطلبات الضعيفة.",
  "Open seller moderation": "مراجعة البائعين",
  "Review listing queue": "طابور العروض",
  "Check parts waiting for approval and maintain data quality across the marketplace.": "راجع القطع المنتظرة وجودة البيانات.",
  "Open part moderation": "مراجعة القطع",
  "Moderate buyer reviews": "مراجعة التقييمات",
  "Keep review quality high and remove low-value or harmful feedback before it goes live.": "حافظ على جودة التقييمات واحذف المسيئة.",
  "Open review moderation": "مراجعة التقييمات",
  "Admin priorities": "الأولويات",
  "1. Clear pending sellers": "1. معالجة البائعين المنتظرين",
  "Seller verification is the first trust gate of the marketplace.": "التحقق من البائعين هو أول ضمان للثقة.",
  "2. Approve high-quality parts": "2. الموافقة على القطع الجيدة",
  "Better listing quality improves search trust and conversion quality.": "العروض الأفضل تزيد الثقة والمبيعات.",
  "3. Monitor order flow": "3. متابعة الطلبيات",
  "Keep an eye on payment, shipping, and any order pipeline friction.": "راقب الدفع والتوصيل وأي عرقلة.",
  "Snapshot": "نظرة سريعة",
  "Moderation load": "حجم المراجعة",
  "Supply base": "قاعدة العرض",
  "Live catalog": "الكتالوج المنشور",
  "Commercial activity": "النشاط التجاري",
  "Revenue tracked": "الإيرادات",
  "Page not found": "الصفحة غير موجودة",
  "This admin route does not exist or has not been implemented yet.": "هذه الصفحة غير موجودة.",
  "Go to dashboard": "إلى لوحة التحكم",
  "Failed to load orders": "تعذّر تحميل الطلبيات",
  "Orders overview": "نظرة على الطلبيات",
  "Inspect order pipeline health and monitor marketplace fulfillment status.": "تابع الطلبيات وتنفيذها.",
  "Loading orders...": "جارٍ تحميل الطلبيات…",
  "No orders available yet.": "لا توجد طلبيات بعد.",
  "Order #{id}": "الطلبية رقم {id}",
  "buyer: {name}": "المشتري: {name}",
  "unknown": "غير معروف",
  "no email": "بدون بريد",
  "status: {status}": "الحالة: {status}",
  "payment: {status}": "الدفع: {status}",
  "shipping: {status}": "التوصيل: {status}",
  "total: {price}": "المجموع: {price}",
  "Failed to load part details": "تعذّر تحميل تفاصيل القطعة",
  "Failed to update part status": "تعذّر تغيير حالة القطعة",
  "Loading part details...": "جارٍ تحميل تفاصيل القطعة…",
  "Part not found": "القطعة غير موجودة",
  "Part details": "تفاصيل القطعة",
  "Review listing quality, fitment depth, and approval readiness.": "راجع جودة العرض وبيانات التوافق.",
  "Back to parts": "العودة إلى القطع",
  "Approve": "موافقة",
  "Reject": "رفض",
  "Archive": "أرشفة",
  "Message to seller:": "رسالة للبائع:",
  "Slug:": "الرابط:",
  "SKU:": "SKU:",
  "Not provided": "غير متوفّر",
  "Seller:": "البائع:",
  "Unknown": "غير معروف",
  "Brand:": "العلامة:",
  "Category:": "الصنف:",
  "Price:": "السعر:",
  "Quantity:": "الكمية:",
  "Description": "الوصف",
  "No description available.": "لا يوجد وصف.",
  "Media": "الصور",
  "No media found for this part.": "لا توجد صور.",
  "featured: {value}": "مميّزة: {value}",
  "yes": "نعم",
  "no": "لا",
  "Compatibility": "التوافق",
  "No compatibility rows found.": "لا توجد توافقات.",
  "Specifications": "المواصفات",
  "No specifications available.": "لا توجد مواصفات.",
  "Moderation guidance": "إرشادات المراجعة",
  "• Approve listings with strong data quality and believable fitment information.": "• وافق على العروض الكاملة ذات التوافق المعقول.",
  "• Reject parts with weak, incomplete, or suspicious marketplace signals.": "• ارفض العروض الناقصة أو المشبوهة.",
  "• Archive listings that should no longer appear in the active marketplace.": "• أرشف العروض التي لا يجب أن تظهر.",
  "View seller profile": "عرض البائع",
  "Open the seller details page to review broader trust context.": "افتح صفحة البائع لمزيد من السياق.",
  "Open seller details": "تفاصيل البائع",
  "Failed to load parts": "تعذّر تحميل القطع",
  "Part moderation": "مراجعة القطع",
  "Review marketplace listings, approve high-quality parts, and reject poor or invalid submissions.": "وافق على العروض الجيدة وارفض الضعيفة.",
  "Loading parts...": "جارٍ تحميل القطع…",
  "1 listing": "عرض واحد",
  "{n} listings": "{n} عروض",
  "Loading moderation queue...": "جارٍ التحميل…",
  "No parts found for this status.": "لا توجد قطع بهذه الحالة.",
  "seller: {seller}": "البائع: {seller}",
  "price: {price}": "السعر: {price}",
  "No part description available.": "لا يوجد وصف.",
  "View details": "عرض التفاصيل",
  "Failed to load reviews": "تعذّر تحميل التقييمات",
  "Failed to update review status": "تعذّر تغيير حالة التقييم",
  "Review moderation": "مراجعة التقييمات",
  "Approve real buyer feedback and reject low-quality or policy-breaking reviews.": "وافق على التقييمات الحقيقية وارفض المخالفة.",
  "Loading reviews...": "جارٍ تحميل التقييمات…",
  "No pending reviews right now.": "لا توجد تقييمات منتظرة حالياً.",
  "Unknown part": "قطعة غير معروفة",
  "rating: {n}/5": "التقييم: {n}/5",
  "No review text provided.": "بدون تعليق.",
  "Failed to load seller details": "تعذّر تحميل تفاصيل البائع",
  "Failed to update seller status": "تعذّر تغيير حالة البائع",
  "Loading seller details...": "جارٍ تحميل البائع…",
  "Seller not found": "البائع غير موجود",
  "Seller details": "تفاصيل البائع",
  "Review seller trust, listing quality, and onboarding status.": "راجع موثوقية البائع وعروضه.",
  "Back to sellers": "العودة إلى البائعين",
  "Suspend": "إيقاف",
  "Email:": "البريد:",
  "Phone:": "الهاتف:",
  "WhatsApp:": "واتساب:",
  "Location:": "الموقع:",
  "Created at:": "تاريخ الإنشاء:",
  "No seller description available.": "لا يوجد وصف للبائع بعد.",
  "Seller parts": "قطع البائع",
  "Review listings associated with this seller account.": "عروض هذا البائع.",
  "No parts found for this seller.": "لا توجد قطع لهذا البائع.",
  "• Approve sellers with complete identity and trustworthy listing quality.": "• وافق على البائعين الكاملين والموثوقين.",
  "• Suspend sellers when quality or response confidence is unclear.": "• أوقف البائع عند الشك في الجودة.",
  "• Reject weak onboarding when trust signals are too low.": "• ارفض الطلبات الضعيفة.",
  "Quick actions": "إجراءات سريعة",
  "Approve seller": "الموافقة على البائع",
  "Suspend seller": "إيقاف البائع",
  "Reject seller": "رفض البائع",
  "Failed to load sellers": "تعذّر تحميل البائعين",
  "Seller moderation": "مراجعة البائعين",
  "Review seller onboarding status, approve trusted suppliers, and suspend problematic accounts.": "وافق على البائعين الموثوقين وأوقف الحسابات المخالفة.",
  "All sellers": "كل البائعين",
  "Loading sellers...": "جارٍ تحميل البائعين…",
  "1 seller": "بائع واحد",
  "{n} sellers": "{n} بائعين",
  "Loading seller moderation queue...": "جارٍ التحميل…",
  "No sellers found for this filter.": "لا يوجد بائعون بهذا الفلتر.",
  "email: {email}": "البريد: {email}",
  "phone: {phone}": "الهاتف: {phone}",
  "n/a": "غير متوفّر",
  "No seller description provided yet.": "لا يوجد وصف بعد.",
  "Failed to load vehicle makes": "تعذّر تحميل العلامات",
  "Failed to load vehicle models": "تعذّر تحميل الطرازات",
  "Failed to load vehicle years": "تعذّر تحميل السنوات",
  "Vehicles reference": "مرجع السيارات",
  "Vehicle coverage explorer": "تغطية السيارات",
  "Review the current make, model, and year coverage available in the marketplace vehicle dataset.": "العلامات والطرازات والسنوات المتوفّرة.",
  "Makes loaded": "العلامات",
  "Models shown": "الطرازات",
  "Years shown": "السنوات",
  "Vehicle selector": "اختيار السيارة",
  "Inspect available models and years from the current dataset.": "الطرازات والسنوات المتوفّرة.",
  "Make": "العلامة",
  "Loading makes...": "جارٍ تحميل العلامات…",
  "Select make": "اختر العلامة",
  "Model": "الطراز",
  "Choose make first": "اختر العلامة أولاً",
  "Loading models...": "جارٍ تحميل الطرازات…",
  "Select model": "اختر الطراز",
  "Coverage details": "التفاصيل",
  "Models": "الطرازات",
  "No models loaded.": "لا توجد طرازات.",
  "Years": "السنوات",
  "Loading years...": "جارٍ تحميل السنوات…",
  "No years loaded.": "لا توجد سنوات.",
  "Photos don't show the actual part. Please upload real photos.": "الصور لا تُظهر القطعة الحقيقية. ارفع صوراً حقيقية.",
  "Title or description doesn't match the part shown.": "العنوان أو الوصف لا يطابق القطعة.",
  "Price looks wrong. Check it's entered in MAD.": "السعر يبدو خاطئاً. تأكد أنه بالدرهم.",
  "Add vehicle compatibility for this vehicle-specific part.": "أضف توافق السيارات لهذه القطعة.",
  "This item isn't allowed on PartHub.": "هذا المنتج غير مسموح على PartHub.",
  "Duplicate of another listing.": "مكرر لعرض آخر.",
  "Out of stock for a long time.": "غير متوفّر منذ مدة طويلة.",
  "Store details are incomplete or unclear. Add a clear name, city and description.": "معلومات المتجر ناقصة. أضف اسماً ومدينة ووصفاً واضحاً.",
  "We couldn't verify your contact number.": "لم نتمكن من التحقق من رقمك.",
  "This store looks like a duplicate of an existing account.": "هذا المتجر يبدو مكرراً لحساب موجود.",
  "Repeated buyer complaints about delivered parts.": "شكاوى متكرّرة من المشترين.",
  "Listings don't match the parts delivered.": "العروض لا تطابق القطع المسلَّمة.",
  "Breach of the PartHub seller policy.": "مخالفة سياسة البائعين في PartHub.",
  "Dashboard": "لوحة التحكم",
  "Categories": "الأصناف",
  "Vehicles": "السيارات",
  "Orders": "الطلبيات",
  "Reviews": "التقييمات",
  "Analytics": "التحليلات",
  "New": "جديد",
  "Used": "مستعملة",
  "Refurbished": "مُجدّدة",
  "Pending": "قيد الانتظار",
  "Confirmed": "مؤكَّد",
  "Processing": "قيد التجهيز",
  "Shipped": "تم الشحن",
  "Delivered": "تم التوصيل",
  "Cancelled": "ملغى",
  "Paid": "مدفوع",
  "Unpaid": "غير مدفوع",
  "Failed": "فشل",
  "Refunded": "مسترجع",
  "Active": "نشط",
  "Draft": "مسودة",
  "Archived": "مؤرشف",
  "Rejected": "مرفوض",
  "Suspended": "موقوف",
  "Approved": "مقبول",
  "Open for offers": "مفتوح للعروض",
  "Closed": "مغلق",
  "Fulfilled": "تمّت تلبيته",
  "Expired": "منتهي",
  "Accepted": "مقبول",
  "Declined": "مرفوض",
  "Withdrawn": "مسحوب",
  "Not shipped": "لم يُشحن",
  "In transit": "في الطريق",
};
